import { instance } from './instance';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d{1,2})){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // On localhost, check if the SW file actually exists (dev server won't have one)
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

export function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Poll for updates every 5 minutes — important for iOS Safari which
      // doesn't reliably check for SW updates on its own.
      setInterval(() => {
        registration.update();
      }, 5 * 60 * 1000);

      // A new worker becomes "an update" the moment it is installed while an
      // old one still controls the page. Three ways this page can meet one:
      //
      //  1. Already WAITING when the page loads. The update was found on an
      //     earlier load (or in another tab) and never applied. No event fires
      //     for it, ever: the only signal is `registration.waiting` being set.
      //     Missing this check was why the prompt sometimes never showed and a
      //     reload kept serving the old build: the old worker keeps handing out
      //     its precached index.html until the waiting one is let through.
      //  2. Still INSTALLING when the page loads (a reload mid-install). Track it.
      //  3. Found later, by the 5-minute update() poll or by the browser. That
      //     is `updatefound`, and it fires in EVERY tab holding the
      //     registration, so every open tab learns about it on its own.
      //
      // `atLoad` separates the first two from the third. A page meets a worker
      // at load right after fetching its HTML from the network, so it already
      // runs the build that worker carries and needs no reload; an update found
      // later means this tab is the old build.
      const announce = (atLoad) => {
        console.log(`New ${instance.displayName} version available.`);
        if (config && config.onUpdate) config.onUpdate(registration, { atLoad });
      };
      const track = (worker, atLoad) => {
        if (!worker) return;
        worker.onstatechange = () => {
          if (worker.state !== 'installed') return;
          if (navigator.serviceWorker.controller) {
            announce(atLoad);
          } else {
            // First-time cache: content is available offline
            console.log(`${instance.displayName} is cached for faster loading.`);
            if (config && config.onSuccess) config.onSuccess(registration);
          }
        };
      };
      // No `controller` guard here: a worker cannot be waiting without an active
      // one, and a page that is UNCONTROLLED (a hard reload bypasses the worker
      // for that navigation) still has to hear, or that tab is blind for life.
      if (registration.waiting) announce(true);
      track(registration.installing, true);
      registration.onupdatefound = () => track(registration.installing, false);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found — probably dev server. Unregister any stale one.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
